import React from "react";
import { cn } from "@adora/shadcn-ui";
import { Z_COMMAND_BAR } from "../../constants/z-index";

/**
 * Sticky filter/command bar shell.
 *
 * The row stays on one line and scrolls horizontally when it doesn't fit. This used to branch on the
 * right-hand sidebar's open state — wrapping onto multiple lines while it was open, scrolling otherwise
 * — which made the bar behave differently depending on which side panel happened to be expanded. The
 * scroll behaviour is now unconditional so it's the same in every state.
 */
export const CommandBarWrapper = ({
  children,
  commonPageHeaderSpacing = false,
  radioPlusOverflowStyle = false,
  additionalContent = null,
  style = {}
}: {
  children: React.ReactNode;
  commonPageHeaderSpacing?: boolean;
  radioPlusOverflowStyle?: boolean;
  additionalContent?: React.ReactNode;
  style?: React.CSSProperties;
}) => (
  <div
    className={cn(
      "flex flex-col items-center justify-center gap-3 shrink-0 py-2 sticky bg-background print:static print:!shadow-none",
      commonPageHeaderSpacing && "mb-[72px]",
      // A phone's scrollbar shows faintly on load and lingers until the row is scrolled, so it's hidden there.
      "overflow-x-auto whitespace-nowrap items-center max-md:scrollbar-hide"
    )}
    style={{
      top: "var(--page-sticky-offset, 68px)",
      boxShadow: "0 -1px 0 2px white",
      zIndex: Z_COMMAND_BAR,
      ...style
    }}
  >
    {radioPlusOverflowStyle && <div className="p-2 w-6 h-6 invisible mr-2"></div>}
    <div className="flex gap-2 items-center flex-nowrap mx-auto">{children}</div>
    {additionalContent}
  </div>
);
